import { apiClient } from './ApiClient';
export type Artifact = {
  id: string;
  createTime?: string;
  lastReleaseId?: string;
  lastReleaseVersion?: string;
  lastUpdateTime?: string;
  typeName: string;
  semver: string;
};
export type ArtifactType = {
  typeName: string;
  fileExtension: string;
  compatibleDeviceTypes: string[];
};
export type GroupedArtifact = {
  artifacts: Artifact[];
  typeName: string;
};

export const getArtifactGroups = async (
  deviceType: string,
): Promise<GroupedArtifact[]> => {
  const response = await apiClient
    .getClient()
    .get(`artifact-groups?deviceType=${deviceType}`);
  return response.data;
};
